<template>
<nav class="bottom-nav-bar"><ul class="bottom-nav-bar__items">
  <li class="bottom-nav-bar__item bottom-nav-bar__item-home">
    <router-link
      :to="{ name: 'home' }"
      class="bottom-nav-bar__item-content"
    >
      <IconHome class="bottom-nav-bar__icon"/>
      <p class="text-center text-2xs text-dark mt-1">Главная</p>
    </router-link>
  </li>
  <li class="bottom-nav-bar__item">
    <router-link
      :to="{ name: 'categories' }"
      class="bottom-nav-bar__item-content"
    >
      <IconItems class="bottom-nav-bar__icon"/>
      <p class="text-center text-2xs text-dark mt-1">Каталог</p>
    </router-link>
  </li>
  <li class="bottom-nav-bar__item bottom-nav-bar__item-cart">
    <button
      @click="$store.commit('ui/toggleCartModal')"
      class="bottom-nav-bar__item-content"
    >
      <div class="bottom-nav-bar__cart-icon-wrapper">
        <IconBasket class="bottom-nav-bar__icon"/>
        <span
          v-if="$store.getters['order/totalQuantity'] > 0"
          class="bottom-nav-bar__cart-badge"
        >{{ $store.getters['order/totalQuantity'] }}</span>
      </div>
      <p class="text-center text-2xs text-dark mt-1">Корзина</p>
    </button>
  </li>
  <li v-if="activeCityPhone" class="bottom-nav-bar__item bottom-nav-bar__item-call">
    <a
      :href="`tel:${activeCityPhone.e164}`"
      class="bottom-nav-bar__item-content"
    >
      <IconPhone class="bottom-nav-bar__icon bottom-nav-bar__icon-phone"/>
      <p class="text-center text-2xs text-dark mt-1">Позвонить</p>
    </a>
  </li>
  <li class="bottom-nav-bar__item">
    <router-link
      :to="{ name: 'more' }"
      class="bottom-nav-bar__item-content"
    >
      <IconDots class="bottom-nav-bar__icon"/>
      <p class="text-center text-2xs text-dark mt-1">Ещё</p>
    </router-link>
  </li>
</ul></nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    IconHome: () => import(/* webpackPreload: true */ '@/assets/images/icons/bottom-bar/home.svg?inline'),
    IconPhone: () => import(/* webpackPreload: true */ '@/assets/images/icons/bottom-bar/callback.svg?inline'),
    IconBasket: () => import(/* webpackPreload: true */ '@/assets/images/icons/bottom-bar/cart.svg?inline'),
    IconItems: () => import(/* webpackPreload: true */ '@/assets/images/icons/bottom-bar/catalog.svg?inline'),
    IconDots: () => import(/* webpackPreload: true */ '@/assets/images/icons/bottom-bar/more.svg?inline'),
  },

  computed: {
    ...mapGetters({
      activeCityPhone: 'store/activeCityPhone',
    }),
  },
}
</script>

<style lang="less">
@r: bottom-nav-bar;
.@{r} {
  @apply sticky bottom-0 bg-white border-t border-grey-light
    z-bottom-nav-bar; // Has been overlapped by offers cards and swiper pagination bullets.

  padding-bottom: 1rem;
  &__items {
    @apply flex;
  }
  &__item {
    @apply flex-grow;
    flex-basis: 0;
    &.@{r}__item-cart {
      .@{r}__icon {
        @apply fill-current text-primary w-6;
        stroke: none;
      }
      .@{r}__cart-icon-wrapper {
        @apply relative inline-block ;
        line-height: 0; // So the content is centered;
        .@{r}__cart-badge {
          @apply absolute text-dark-darker text-2xs font-medium rounded-full bg-secondary h-4 border border-white
            flex items-center justify-center;
          box-sizing: content-box;
          min-width: theme('width.4');
          top: -9px;
          right: -9px;
        }
      }
    }
  }
  &__item-content {
    @apply flex items-center justify-center flex-col;
    height: theme('customVars.bottomNavBar.height');
    button& {
      @apply w-full text-center;
      > * {
        @apply align-middle;
      }
    }
  }
  &__icon {
    @apply text-primary;
    @color: theme('colors.dark');
    fill: @color;
  }
}
</style>
